import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.tsx';

import * as serviceWorker from './serviceWorker';

// Configure API URL from environment variables
const API_URL = import.meta.env.VITE_API_URL;
window.API_URL = API_URL;
// Load system script
const script = document.createElement('script');
script.src = `${API_URL}/api/system.js`;
document.head.appendChild(script);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
